var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.config.InnerStyle)},[_c('div',{staticClass:"line2",attrs:{"title":_vm.Label}},[_vm._v(" "+_vm._s(_vm.Label || ' ')+" "),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }